import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIndicator from 'src/components/atoms/error-indicator';
import { NamesListTooltip } from 'src/components/molecules/names-list-tooltip';

export interface SpaceGroupsActionsSlotPayload {
  token: string;
  name: string;
  employeesGroupsTokens: string[];
}

interface Props {
  token: string;
  name: string;
  employeesGroupsTokens: string[];
  employeesGroupsNames: string[];
  actionsSlot: (payload: SpaceGroupsActionsSlotPayload) => ReactNode;
  hasAnySpacesAdded: boolean;
}

export const SpaceGroupsTableRow = ({
  token,
  name,
  employeesGroupsTokens,
  employeesGroupsNames,
  actionsSlot,
  hasAnySpacesAdded,
}: Props) => {
  const { t } = useTranslation(['spaceGroups', 'common']);

  const navigate = useNavigate();

  const location = useLocation();

  return (
    <TableRow
      hover
      sx={{ cursor: 'pointer' }}
      onClick={() =>
        navigate({
          to: '/tenant/spaces/groups/$spaceGroupToken',
          params: { spaceGroupToken: token },
          state: { backUrl: location.href },
        })
      }>
      <TableCell>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <ErrorIndicator
            tooltipTitle={t('spaceGroups:common.noSpacesTooltip')}
            visible={!hasAnySpacesAdded}
            color="warning.secondary"
          />

          <Typography variant="inherit">{name}</Typography>
        </Box>
      </TableCell>

      <TableCell>
        <NamesListTooltip
          names={employeesGroupsNames}
          emptyText={t('common:notAssigned')}
          pluralText={t('spaceGroups:common.groups')}
        />
      </TableCell>

      <TableCell align="right">
        {actionsSlot({ token, name, employeesGroupsTokens })}
      </TableCell>
    </TableRow>
  );
};
